import {decodeEncryptedIdForBroadcaster} from "../../broadcast_util";
import {getCDNImage, isEmpty} from "../../utility";
import {getData, USER_DATA} from "../../storage";

const getBroadcasterId = (props) => {

    if (props.match.hasOwnProperty("params") &&
        props.match.params &&
        props.match.params.hasOwnProperty("id")) {
        if (props.match.params.id !== "video" || props.match.params.id !== "gallery") {
            return decodeEncryptedIdForBroadcaster(props.match.params.id);
        }

        return -1;
    } else {
        return -1;
    }
}

const getUserId = (props) => {
    return getBroadcasterId(props);
}

const getBroadcasterAttribute = (broadcaster, default_value, $key = "channel_image_square") => {
    if (broadcaster !== null &&
        broadcaster.hasOwnProperty("channel_image") &&
        broadcaster["channel_image"].hasOwnProperty("bucket") &&
        broadcaster["channel_image"].hasOwnProperty("key")) {

        if ($key === "channel_image_rectangle" || $key === "channel_image_square") {
            return getCDNImage(broadcaster["channel_image"]["bucket"], broadcaster["channel_image"]["key"], 1000)
        }
        return broadcaster[$key]
    } else {
        return default_value;
    }
}

const getUserData = (callback) => {
    getData(USER_DATA)
        .then((data) => {
            if (!isEmpty(data)) {
                callback(data)
            } else {
                callback(null)
            }
        });
}

export default {
    getBroadcasterId,
    getUserId,
    getBroadcasterAttribute,
    getUserData
}